import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
//outsource
import { Row, Col, Space, Button } from "antd";
//components
import BranchSelect from "./component/branch_select";
import TimeFrom from "./component/time_from";
import TimeTo from "./component/time_to";
import SortTo from "./component/sort_to_status";
import { useNavigate } from "react-router-dom";
import { ExportDataCSV } from "../function/export_csv";
import { useDispatch } from "react-redux";
import { incomeSelector } from "../../../store/income/income.selector";
import { useSelector } from "react-redux";
import { snapDetail, unSnapDetail } from "../../../store/branch/branch.action";
import {
  getUserInfo,
  snapAllIncomeByBranch,
  unSnapIncomeByBranch,
} from "../../../store/incomeStaff/incomeStaff.action";
import {
  incomeByBranchSelector,
  userInfoSelector,
} from "../../../store/incomeStaff/incomeStaff.selector";
import { detailSelector } from "../../../store/branch/branch.selector";
import moment from "moment";
import lodash from "lodash";
import { allStaffsSelector } from "../../../store/staff/staff.selector";

const CashupReportTopbar = (props) => {
  // -------------------------- VAR --------------------------
  const { branch, setBranch } = props;
  const { reportData } = props;
  const { from, setFrom } = props;
  const { to, setTo } = props;
  const { status, setStatus } = props;
  const { cashUpList } = props;
  const { branchs } = props;

  const navigate = useNavigate();
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  const branchDetails = useSelector(detailSelector);
  const incomeByBranch = useSelector(incomeByBranchSelector);
  const userInfo = useSelector(userInfoSelector);
  // const activStaffs = useSelector(allStaffsSelector);
  // ------------------------- FUNCTION --------------------------
  const handleExport = () => {
    const cashup = cashUpList?.filter((item) => item?.status === "confirmed");
    const dateRange = cashup?.map((item) => item?.date);
    const incomeStaff = incomeByBranch?.filter((item) =>
      dateRange?.includes(item?.date)
    );
    // sort By level and name
    const sortByName = lodash.sortBy(userInfo, ["firstName", "lastName"]);
    const levels = [
      "Level 4",
      "Level 3",
      "Level 2",
      "Level 1",
      "Trainee",
      "",
      null,
    ];
    const sortByLevel = lodash.sortBy(sortByName, (item) =>
      lodash.indexOf(levels, item?.level)
    );
    const coop = sortByLevel.map((item) => item?.id);
    let selectedBranch = branchDetails;
    selectedBranch = { ...selectedBranch, coop };

    const users = userInfo;
    const start = moment(from?._d)?.format("DD/MM/YYYY");
    const end = moment(to?._d)?.format("DD/MM/YYYY");

    ExportDataCSV({
      selectedBranch,
      users,
      cashup,
      incomeStaff,
      from: start,
      to: end,
    });
  };
  // -------------------------- EFFECT --------------------------
  useEffect(() => {
    if (branch && from && to) {
      const branchId = branchs?.find((item) => item?.name === branch)?.id;
      dispatch(snapAllIncomeByBranch({ from, to, branchId }));
      dispatch(snapDetail({ id: branchId }));
      return () => {
        dispatch(unSnapIncomeByBranch());
        dispatch(unSnapDetail());
      };
    }
  }, [dispatch, from, to, branch]);

  useEffect(() => {
    if (branchDetails) {
      //activeCoop
      // const activeBranchStaffs =
      //   activStaffs && activStaffs?.filter((a) => a?.branch === branchId);
      const coop = branchDetails?.coop || [];

      let staff = [];
      incomeByBranch?.forEach((item) => {
        item?.staff?.forEach((s) => staff.push(s?.userId));
      });
      //unique staff
      const uniqueStaff = lodash.uniq([...coop, ...staff]);

      // const idsActiveStaff = activeBranchStaffs?.map((active) => active?.staff);

      // const diff = coop?.filter((c) => {
      //   const valids = idsActiveStaff?.includes(c) || false;
      //   return valids;
      // });

      // dispatch(getUserInfo({ userIdList: coop }));
      dispatch(getUserInfo({ userIdList: uniqueStaff }));
    }
  }, [dispatch, branchDetails, incomeByBranch]);
  // -------------------------- RENDER --------------------------
  const renderBody = () => {
    return (
      <Row>
        <Col xl={24} lg={24} md={24} xs={24}>
          {renderTitle()}
        </Col>
      </Row>
    );
  };

  const renderTitle = () => {
    return (
      <Row gutter={[10, 10]}>
        <Col xl={6} lg={6} md={6} xs={12}>
          <BranchSelect
            branch={branch}
            setBranch={setBranch}
            reportData={reportData}
          />
        </Col>
        <Col xl={4} lg={4} md={4} xs={12}>
          <TimeFrom from={from} setFrom={setFrom} to={to} />
        </Col>
        <Col xl={4} lg={4} md={4} xs={12}>
          <TimeTo from={from} to={to} setTo={setTo} />
        </Col>
        <Col xl={4} lg={4} md={4} xs={12}>
          <SortTo status={status} setStatus={setStatus} />
        </Col>
        <Col xl={4} lg={4} md={4} xs={24}>
          {renderExportData()}
        </Col>
        <Col align="right" xl={2} lg={2} md={2} xs={24}>
          <Button
            type="primary"
            size="small"
            onClick={() => navigate(`/report`)}
          >
            Back
          </Button>
        </Col>
      </Row>
    );
  };

  const renderExportData = () => {
    const disabled = branch === "" || branch === "all" ? true : false;
    return (
      <Button type="primary" disabled={disabled} onClick={handleExport}>
        Export to csv
      </Button>
    );
  };
  // -------------------------- MAIN --------------------------
  return (
    <Row>
      <Col xl={24} lg={24} md={24} xs={24}>
        {renderBody()}
      </Col>
    </Row>
  );
};

export default CashupReportTopbar;
